import MovieFilterOutlinedIcon from '@mui/icons-material/MovieFilterOutlined';

export const ComposeIcon = MovieFilterOutlinedIcon;
